export default __webpack_public_path__ + "static/media/kart.4fc75eee.jpg";